export function sportSortFunc(a, b) {
    let compare = a.get('priority') - b.get('priority');

    if (compare === 0) {
        compare = a.get('name').localeCompare(b.get('name'));
    }

    return compare;
}

export function leagueSortFunc(a, b) {
    let compare = a.get('priority') - b.get('priority');

    if (compare === 0) {
        compare = a.get('name').localeCompare(b.get('name'));
    }

    return compare;
}

export function matchSortFunc(a, b) {
    return a.get('name').localeCompare(b.get('name'));
}

export function matchStartDateSortFunc(a, b) {
    const compare = a.get('type') - b.get('type');

    if (compare === 0) {
        const aDate = a.get('startDate');
        const bDate = b.get('startDate');

        if (aDate > bDate) {
            return 1;
        } else if (aDate < bDate) {
            return -1;
        }

        return 0;
    }

    return compare;
}

export function groupsSortFunc(a, b) {
    const aPriority = a.get('priority');
    const bPriority = b.get('priority');

    if (aPriority > bPriority) {
        return 1;
    } else if (aPriority < bPriority) {
        return -1;
    }

    const aType = a.get('type');
    const bType = b.get('type');

    if (aType > bType) {
        return 1;
    } else if (aType < bType) {
        return -1;
    }

    return 0;
}



// WEBPACK FOOTER //
// ./js/rendering-commons/Sorting.js